import React from 'react'
// import the progress bar
import StepProgressBar from 'react-step-progress';
// import the stylesheet
import 'react-step-progress/dist/index.css';
import Nav from '../Nav/Nav';
import './verifyCustomer.css'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

/******************* FOR SELLERS */
// setup the step content
const step1Content =
                    <>
                      <div className="VerifyTitle">You are </div>
                      <div className="VerifyContent">
                        <span><input type="radio" name="v1" id="" selected disabled/>Seller</span><br/>
                      </div>
                    </>;
const step2Content =  <>
                        <div className="VerifyTitle">Upload Aadhar Card </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step3Content =  <>
                        <div className="VerifyTitle">Upload Passport size Photo </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step4Content =  <>
                        <div className="VerifyTitle">Upload Old Sales Deed</div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step5Content =  <>
                        <div className="VerifyTitle">Upload NOC(no objection certificate) </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step6Content =  <>
                        <div className="VerifyTitle">UploadRegistration Card</div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step7Content =  <>
                        <div className="VerifyTitle">Upload Municipal Tax Bill </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step8Content =  <>
                        <div className="VerifyTitle">Upload Construction Completion Certificate </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      
</>;
const step9Content =  <>
                        <div className="VerifyTitle">Upload Application Form (signed by Registrar) </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;

/******************* FOR BUYERS */
// setup the step content
const step1ContentBuy =
                    <>
                      <div className="VerifyTitle">You are </div>
                      <div className="VerifyContent">
                        <span><input type="radio" name="v1" id="" selected disabled/>Buyer</span><br/>
                      </div>
                    </>;
const step2ContentBuy =  <>
                        <div className="VerifyTitle">Upload Aadhar Card </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step3ContentBuy =  <>
                        <div className="VerifyTitle">Upload Passport size Photo </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step4ContentBuy =  <>
                        <div className="VerifyTitle">Upload Bank Details</div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step5ContentBuy =  <>
                        <div className="VerifyTitle">Upload NOC(no objection certificate) </div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;
const step6ContentBuy =  <>
                        <div className="VerifyTitle">Upload Cancelled Cheque</div>
                        <div className="VerifyContent">
                          <span><input type="file" name="v1" id="" /></span><br/>
                        </div>
                      </>;


// setup step validators, will be called before proceeding to the next step
function step2Validator() {
  // return a boolean
  return true;
}
 
function step3Validator() {
  // return a boolean
}
 

const VerifyCustomer = () => {
    const navigate=useNavigate();
    async function  toastAdd(){
      toast.success('Check in "Orders" .')
      toast.success('Please wait for agent to verify purchase.')
      setTimeout(()=>{navigate('/orders')},3000);
    }

    function onFormSubmit() {
      // handle the submit logic here
      // This function will be executed at the last step
      // when the submit button (next button in the previous steps) is pressed
      toastAdd();
    }

  return (
    <div>
    <Nav/>  <br/>  <br/>  <br/>  <br/>
    <StepProgressBar
      startingStep={0}
      onSubmit={onFormSubmit}
      steps={[
            {
              label: 'Step 1',
              subtitle: '10%',
              name: 'step 1',
              content: step1Content
            },
            {
              label: 'Step 2',
              subtitle: '50%',
              name: 'step 2',
              content: step2Content,
            },
            {
              label: 'Step 3',
              subtitle: '100%',
              name: 'step 3',
              content: step3Content,
             // validator: step3Validator
            },
            {
              label: 'Step 4',
              subtitle: '100%',
              name: 'step 4',
              content: step4Content,
            },
            {
              label: 'Step 5',
              subtitle: '100%',
              name: 'step 5',
              content: step5Content,
            },
            {
              label: 'Step 6',
              subtitle: '100%',
              name: 'step 6',
              content: step6Content,
            },
            {
              label: 'Step 7',
              subtitle: '100%',
              name: 'step 7',
              content: step7Content,
            },
            {
              label: 'Step 8',
              subtitle: '100%',
              name: 'step 8',
              content: step8Content,
            },
            {
              label: 'Step 9',
              subtitle: '100%',
              name: 'step 9',
              content: step9Content,
            }
          ]}
        />;


        <ToastContainer/>  <br/>  <br/>  <br/> 


        <StepProgressBar
      startingStep={0}
      onSubmit={onFormSubmit}
      steps={[
            {
              label: 'Step 1',
              subtitle: '10%',
              name: 'step 1',
              content: step1ContentBuy
            },
            {
              label: 'Step 2',
              subtitle: '50%',
              name: 'step 2',
              content: step2ContentBuy,
            },
            {
              label: 'Step 3',
              subtitle: '100%',
              name: 'step 3',
              content: step3ContentBuy,
             // validator: step3Validator
            },
            {
              label: 'Step 4',
              subtitle: '100%',
              name: 'step 4',
              content: step4ContentBuy,
            },
            {
              label: 'Step 5',
              subtitle: '100%',
              name: 'step 5',
              content: step5ContentBuy,
            },
            {
              label: 'Step 6',
              subtitle: '100%',
              name: 'step 6',
              content: step6ContentBuy,
            },

          ]}
        />;
    </div>
  )
}

export default VerifyCustomer